// src/routes.js
import { lazy } from "react";

// Lazy-loaded components
const DashboardTabs = lazy(() => import("./components/DashboradDesign/DashboardTabs"));
// const Orders = lazy(() => import("./components/Orders/OrderTabs"));
// Add other imports similarly...

const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: DashboardTabs,
  },
  // {
  //   path: "/orders",
  //   name: "Orders",
  //   component: Orders,
  // },
  // Add more routes as needed
];

export default routes;
